import dayjs from 'dayjs';
import { callAPI } from '@/store/socket';

export default {
  namespaced: true,
  state: () => ({
    dayoffs: {},
    holidays: {},
    googleCalendarConnected: false,
  }),
  getters: {
    isOnDayoffToday: (state, getters, rootState) => (userId) => {
      const today = rootState.system.nowUTC.local().format('YYYY-MM-DD');
      return (state.dayoffs[userId] || []).some((d) => d.date === today);
    },
  },
  mutations: {
    setDayoffs(state, list) {
      const map = {};
      list.forEach((d) => {
        if (!map[d.userId]) {
          map[d.userId] = [];
        }
        map[d.userId].push({ date: d.date, description: d.description });
      });
      state.dayoffs = map;
    },
    setGoogleCalendarConnected(state, connected) {
      state.googleCalendarConnected = connected;
    },
    setHolidays(state, list) {
      const map = {};
      list.forEach((h) => { map[h.date] = h.name; });
      state.holidays = map;
    },
    applyDayoffsChanged(state, { userId, from, to, days }) {
      const kept = (state.dayoffs[userId] || []).filter((x) => x.date < from || x.date > to);
      state.dayoffs = {
        ...state.dayoffs,
        [userId]: [...kept, ...days].sort((a, b) => a.date.localeCompare(b.date)),
      };
    },
  },
  actions: {
    async actionLoadDayoffs({ commit }, { from, to, isLatest = () => true }) {
      const { dayoffs, holidays, googleCalendarConnected } = await callAPI({
        method: 'getDayoffsAndSubscribe',
        params: { from, to },
      });
      if (!isLatest()) {
        return false;
      }
      commit('setDayoffs', dayoffs);
      commit('setHolidays', holidays);
      commit('setGoogleCalendarConnected', googleCalendarConnected);
      return true;
    },
    async actionLoadMyDayoffHistory() {
      const { dayoffs } = await callAPI({ method: 'getMyDayoffHistory' });
      return dayoffs;
    },
    async actionConnectGoogleCalendar() {
      const { url } = await callAPI({ method: 'getGoogleCalendarAuthUrl' });
      return url;
    },
    async actionDisconnectGoogleCalendar({ commit }) {
      await callAPI({ method: 'disconnectGoogleCalendar', persisted: true });
      commit('setGoogleCalendarConnected', false);
    },
    async actionLoadTodayDayoffs({ dispatch }) {
      const today = dayjs().format('YYYY-MM-DD');
      await dispatch('actionLoadDayoffs', { from: today, to: today });
    },
    async actionSetDayoffs(_, { from, to, dates, description }) {
      await callAPI({
        method: 'setDayoffs',
        params: { from, to, dates, description },
        persisted: true,
      });
    },
  },
};
